module.exports = __webpack_public_path__ + "static/media/logo_biket.175b3be8.svg";